import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const useStyles = makeStyles({
    root: {
        fontSize: 11,
        fontWeight: 400,
        letterSpacing: '0.46px',
        color: '#0B3F30',
        textTransform: 'uppercase',
        padding: '6px 12px',
        border: 'none',
        borderRadius: 4,
    },
});

export default function ExportButton({ loading, ...props }) {
    const classes = useStyles();
    return (
        <Button
            variant="text"
            disableElevation
            disabled={loading}
            startIcon={<ArrowDownwardIcon style={{ fontSize: 20 }} />}
            className={classes.root}
            {...props}
        >
            {loading ? 'Eksportuojama...' : 'Eksportuoti'}
        </Button>
    );
}
